import { render, staticRenderFns } from "./aestheticScore.vue?vue&type=template&id=35852ad8&scoped=true&"
import script from "./aestheticScore.vue?vue&type=script&lang=js&"
export * from "./aestheticScore.vue?vue&type=script&lang=js&"
import style0 from "./aestheticScore.vue?vue&type=style&index=0&id=35852ad8&prod&lang=scss&scoped=true&"
import style1 from "./aestheticScore.vue?vue&type=style&index=1&id=35852ad8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35852ad8",
  null
  
)

export default component.exports